import { render, staticRenderFns } from "./DonneePreResa.vue?vue&type=template&id=926f2dde&"
import script from "./DonneePreResa.vue?vue&type=script&lang=js&"
export * from "./DonneePreResa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports